<template>
  <div class="main-wrapper">
    <!-- Page Wrapper -->
    <div class="page-wrapper">
      <!-- Page Content -->
      <div class="content container-fluid">
          <!-- Hero -->
          <div class="card border-0 shadow-sm mb-4">
            <div class="card-body d-flex align-items-center justify-content-between flex-wrap">
              <div class="mb-2">
                <h4 class="mb-1 font-weight-bold">Trình Tạo Bài Viết AI</h4>
                <div class="text-muted">Từ khóa → Outline → Title/Desc → Semantic → Nội dung → Đăng</div>
              </div>
              <div class="d-flex align-items-center">
                <span class="badge badge-primary px-3 py-2 mr-2">{{ stepN }}</span>
                <small class="text-muted">/ {{ STEPS_TOTAL }}</small>
                <small v-if="articleId" class="text-success ml-3">#{{ articleId }}</small>
              </div>
            </div>
            <div class="progress rounded-0" style="height:6px">
              <div class="progress-bar bg-primary" :style="{width: percent + '%'}"></div>
            </div>
          </div>

          <!-- Steps -->
          <ul class="nav nav-pills small mb-3 steps-bar">
            <li class="nav-item" v-for="s in steps" :key="s.n">
              <span class="nav-link" :class="stepN >= s.n ? 'active' : 'disabled'">{{ s.n }}. {{ s.label }}</span>
            </li>
          </ul>

          <form @submit.prevent @keydown.enter.prevent>
            <!-- STEP 1 -->
            <div v-if="stepN === 1" class="card p-4 shadow-sm">
              <h5 class="font-weight-semibold mb-3">Bước 1: Thông tin cơ bản</h5>
              <div class="form-row">
                <div class="form-group col-md-4">
                  <label>Ngôn ngữ</label>
                  <select v-model="language" class="form-control">
                    <option value="Tiếng Việt">Tiếng Việt</option>
                    <option value="English">English</option>
                    <option value="Tiếng Trung Quốc">Tiếng Trung Quốc</option>
                    <option value="Tiếng Nhật">Tiếng Nhật</option>
                    <option value="Tiếng Hàn Quốc">Tiếng Hàn Quốc</option>
                    <option value="Tiếng Pháp">Tiếng Pháp</option>
                    <option value="Tiếng Đức">Tiếng Đức</option>
                    <option value="Tiếng Tây Ban Nha">Tiếng Tây Ban Nha</option>
                    <option value="Tiếng Nga">Tiếng Nga</option>
                    <option value="Tiếng Bồ Đào Nha">Tiếng Bồ Đào Nha</option>
                    <option value="Tiếng Ý">Tiếng Ý</option>
                    <option value="Tiếng Ả Rập">Tiếng Ả Rập</option>
                    <option value="Tiếng Thổ Nhĩ Kỳ">Tiếng Thổ Nhĩ Kỳ</option>
                    <option value="Tiếng Hà Lan">Tiếng Hà Lan</option>
                    <option value="Campuchia">Campuchia</option>
                    <option value="Lào">Lào</option>
                    <option value="Thái Lan">Thái Lan</option>
                  </select>
                </div>
                <div class="form-group col-md-4">
                  <label>Schema</label>
                  <select v-model="schemaType" class="form-control">
                    <option value="" disabled>Chọn ngữ cảnh</option>
                    <option value="Article (Bài viết)">Article (Bài viết)</option>
                    <option value="Book (Sách)">Book (Sách)</option>
                    <option value="Course (Khóa học)">Course (Khóa học)</option>
                    <option value="Dataset (Bộ dữ liệu)">Dataset (Bộ dữ liệu)</option>
                    <option value="Event (Sự kiện)">Event (Sự kiện)</option>
                    <option value="FAQ (Câu hỏi thường gặp)">FAQ (Câu hỏi thường gặp)</option>
                    <option value="FactCheck (Kiểm tra thực tế)">FactCheck (Kiểm tra thực tế)</option>
                    <option value="HowTo (Hướng dẫn)">HowTo (Hướng dẫn)</option>
                    <option value="JobPosting (Tin tuyển dụng)">Job Posting (Tin tuyển dụng)</option>
                    <option value="Movie (Phim)">Movie (Phim)</option>
                    <option value="Music (Âm nhạc)">Music (Âm nhạc)</option>
                    <option value="Person (Người)">Person (Người)</option>
                    <option value="Product (Sản phẩm)">Product (Sản phẩm)</option>
                    <option value="Recipe (Công thức nấu ăn)">Recipe (Công thức nấu ăn)</option>
                    <option value="Restaurant (Nhà hàng)">Restaurant (Nhà hàng)</option>
                    <option value="Service (Dịch vụ)">Service (Dịch vụ)</option>
                    <option value="Software (Phần mềm)">Software (Phần mềm)</option>
                  </select>
                </div>
                <div class="form-group col-md-4">
                  <label>Từ khóa chính</label>
                  <input v-model.trim="mainKeyword" class="form-control" placeholder="VD: ống thép mạ kẽm">
                </div>
              </div>
              <div class="mt-2">
                <button type="button" class="btn btn-primary"
                        :disabled="loading || !canCreate"
                        @click.stop.prevent="createArticle">
                  <span v-if="loading" class="spinner-border spinner-border-sm mr-2"></span>
                  Tạo + Sinh SubKeywords
                </button>
              </div>
            </div>

            <!-- STEP 2 -->
            <div v-else-if="stepN === 2" class="card p-4 shadow-sm">
              <div class="d-flex align-items-center justify-content-between mb-2">
                <h5 class="mb-0 font-weight-semibold">Bước 2: Từ khóa phụ</h5>
                <div class="text-muted">Main: <strong>{{ mainKeyword }}</strong></div>
              </div>

              <div class="form-group">
                <label>Danh sách từ khóa phụ</label>
                <textarea v-model="subKeywordsInput" class="form-control" rows="3" placeholder="kw1, kw2, kw3"></textarea>
                <small class="text-muted">Phân tách bằng dấu phẩy (,)</small>
              </div>

              <div class="kw-cloud mb-3">
                <span v-for="(kw, idx) in subKeywords" :key="idx" class="form-check form-check-inline kw-chip">
                  <input class="form-check-input" type="checkbox" :value="kw" v-model="selectedKeywords" :id="'kw-'+idx">
                  <label class="form-check-label" :for="'kw-'+idx">{{ kw }}</label>
                </span>
                <div v-if="subKeywords.length===0" class="text-muted small">Chưa có từ khóa.</div>
              </div>

              <div class="d-flex">
                <button type="button" class="btn btn-outline-secondary mr-2" :disabled="loading" @click.stop.prevent="saveSubKeywords">💾 Lưu</button>
                <button type="button" class="btn btn-primary" :disabled="loading" @click.stop.prevent="generateOutline">
                  <span v-if="loading" class="spinner-border spinner-border-sm mr-2"></span>
                  Sinh Outline
                </button>
              </div>
            </div>

            <!-- STEP 3 -->
            <div v-else-if="stepN === 3" class="card p-4 shadow-sm">
              <h5 class="font-weight-semibold mb-3">Bước 3: Dàn ý</h5>
              <textarea v-model="outline" class="form-control" rows="8" placeholder="Nhập/chỉnh dàn ý..."></textarea>
              <div class="mt-3">
                <button type="button" class="btn btn-primary"
                        :disabled="loading || !outline"
                        @click.stop.prevent="generateTitleDesc">
                  <span v-if="loading" class="spinner-border spinner-border-sm mr-2"></span>
                  Sinh Title & Description
                </button>
              </div>
            </div>

            <!-- STEP 4 -->
            <div v-else-if="stepN === 4" class="card p-4 shadow-sm">
              <h5 class="font-weight-semibold mb-3">Bước 4: Tiêu đề & Mô tả</h5>
              <div class="form-group">
                <label>Tiêu đề</label>
                <input v-model="title" class="form-control" placeholder="Tiêu đề tối ưu SEO...">
              </div>
              <div class="form-group">
                <label>Mô tả</label>
                <textarea v-model="description" class="form-control" rows="3" placeholder="Mô tả meta..."></textarea>
              </div>
              <button type="button" class="btn btn-primary"
                      :disabled="loading || !title || !description"
                      @click.stop.prevent="saveTitleDescThenGenSemantic">
                <span v-if="loading" class="spinner-border spinner-border-sm mr-2"></span>
                Lưu & Sinh Semantic Keywords
              </button>
            </div>

            <!-- STEP 5 -->
            <div v-else-if="stepN === 5" class="card p-4 shadow-sm">
              <h5 class="font-weight-semibold mb-3">Bước 5: Semantic & Internal Link</h5>
              <div class="form-row">
                <div class="form-group col-md-7">
                  <label>Semantic Keywords</label>
                  <textarea v-model="semanticKeywords" class="form-control" rows="3"></textarea>
                </div>
                <div class="form-group col-md-5">
                  <label>Internal Link (chọn 1 website)</label>
                  <select v-model="selectedInternalLink" class="form-control">
                    <option disabled value="">-- Chọn website --</option>
                    <option v-for="s in internalLinkOptions" :key="s.id" :value="s.baseUrl">
                      {{ s.name }} ({{ s.baseUrl }})
                    </option>
                  </select>
                  <small class="text-muted">Chỉ gửi baseUrl xuống BE (VD: https://ongthepbinhduong.com/)</small>
                </div>
              </div>
              <div>
                <button type="button" class="btn btn-primary"
                        :disabled="loading || !selectedInternalLink"
                        @click.stop.prevent="saveUrlAndGenerateContent">
                  <span v-if="loading" class="spinner-border spinner-border-sm mr-2"></span>
                  Lưu URL & Sinh Nội dung
                </button>
              </div>
            </div>

            <!-- STEP 6 -->
            <div v-else-if="stepN === 6" class="card p-4 shadow-sm">
              <h5 class="font-weight-semibold mb-3">Bước 6: Hoàn thiện & Đăng bài</h5>

              <div class="row">
                <!-- LEFT -->
                <div class="col-lg-8">
                  <label class="mb-2">Nội dung</label>
                  <Editor
                    :key="`ed-${articleId}-${stepN}`"
                    v-model="content"
                    :api-key="TINYMCE_KEY"
                    :init="tinymceInit"
                  />

                  <div class="form-row mt-3">
                    <div class="form-group col-md-5">
                      <label>Ảnh đại diện</label>
                      <div class="d-flex">
                        <input v-model="featuredImage" class="form-control mr-2" placeholder="https://.../image.jpg">
                        <button type="button" class="btn btn-outline-secondary" @click.stop.prevent="openAvatarModal">Chọn ảnh</button>
                      </div>
                      <div v-if="featuredImage" class="mt-2">
                        <img :src="featuredImage" class="img-thumbnail shadow-sm" style="max-width:260px" alt="preview">
                      </div>
                    </div>
                    <div class="form-group col-md-3">
                      <label>Slug</label>
                      <input v-model="slug" class="form-control" placeholder="auto nếu để trống">
                    </div>
                    <div class="form-group col-md-4">
                      <label>Focus Keywords</label>
                      <input v-model="focusKeywords" class="form-control" :placeholder="semanticKeywords">
                    </div>
                  </div>

                  <div class="form-group">
                    <label>CTA</label>
                    <select v-model="selectedCtaId" class="form-control">
                      <option value="">-- Chọn CTA --</option>
                      <option v-for="c in availableCtaOptions" :key="c.id" :value="c.id">{{ c.name }}</option>
                    </select>
                    <div v-if="selectedCtaContent" class="cta-preview mt-2 p-3 border rounded bg-light small">
                      <div class="font-weight-semibold mb-1">Nội dung CTA xem trước</div>
                      <div v-html="selectedCtaContent"></div>
                    </div>
                  </div>

                  <div class="mt-2">
                    <button type="button" class="btn btn-outline-secondary mr-2" @click.stop.prevent="normalizeStep(5)">⬅ Quay lại</button>
                    <button type="button" class="btn btn-success" :disabled="loading" @click.stop.prevent="finalizeArticle">
                      ✅ Lưu (Finalize)
                    </button>
                  </div>
                </div>

                <!-- RIGHT -->
                <div class="col-lg-4">
                  <div class="card border-0 shadow-sm sticky-panel">
                    <div class="card-body">
                      <div class="d-flex align-items-center justify-content-between mb-3">
                        <h6 class="mb-0">Đăng lên WordPress</h6>
                        <span v-if="pushing" class="spinner-border spinner-border-sm"></span>
                      </div>

                      <div class="form-group">
                        <label>Website</label>
                        <select v-model="selectedSiteId" class="form-control">
                          <option disabled value="">-- Chọn site --</option>
                          <option v-for="s in sitesForPublish" :key="s.id" :value="s.id">{{ s.name }} ({{ s.baseUrl }})</option>
                        </select>
                      </div>

                      <div class="form-group">
                        <label>Trạng thái</label>
                        <select v-model="postStatus" class="form-control">
                          <option value="publish">publish</option>
                          <option value="draft">draft</option>
                        </select>
                      </div>

                      <div class="form-group">
                        <div class="d-flex align-items-center mb-2">
                          <span class="font-weight-semibold">Danh mục</span>
                          <span v-if="catLoading" class="spinner-border spinner-border-sm ml-2"></span>
                        </div>
                        <div class="cats-scroll">
                          <div class="form-check mb-2" v-for="c in categories" :key="String(c.id)">
                            <input class="form-check-input" type="checkbox" :value="c.id" v-model="selectedCategories" :id="'cat-'+c.id">
                            <label class="form-check-label" :for="'cat-'+c.id">{{ c.name }}</label>
                          </div>
                          <div v-if="!catLoading && categories.length===0" class="text-muted small">Chưa có danh mục hoặc chưa chọn site.</div>
                        </div>
                      </div>

                      <div class="d-flex">
                        <button type="button" class="btn btn-outline-secondary flex-fill mr-2"
                                :disabled="!selectedSiteId || pushing"
                                @click.stop.prevent="testWp">
                          🔎 Kiểm tra kết nối
                        </button>
                        <button type="button" class="btn btn-primary flex-fill"
                                :disabled="pushing || !canPush"
                                @click.stop.prevent="pushToWordpress">
                          <span v-if="pushing" class="spinner-border spinner-border-sm mr-1"></span>
                          🚀 Đăng bài
                        </button>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Done -->
            <div v-else class="alert alert-success">🎉 Hoàn tất!</div>
          </form>

          <!-- File Manager Modal -->
          <FileManagerModal
            v-if="showFileManagerModal"
            :folderTabs="imageTabs"
            @close="showFileManagerModal = false"
            @file-selected="onFileSelected"
            @tab-created="onTabCreated"
            @tab-deleted="onTabDeleted"
          />
        </div>
      </div>
    </div>
</template>

<script setup>
import { ref, watch, computed, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useToast } from 'vue-toastification'
import api from '../api'
import Editor from '@tinymce/tinymce-vue'
import FileManagerModal from '@/components/FileManagerModal.vue'

const toast = useToast()
const route = useRoute()
const router = useRouter()

/* ====== Constants ====== */
const STEPS_TOTAL = 6

/* ====== State ====== */
const step = ref(1)
const steps = [
  { n: 1, label: 'Cơ bản' },
  { n: 2, label: 'SubKeywords' },
  { n: 3, label: 'Outline' },
  { n: 4, label: 'Title/Desc' },
  { n: 5, label: 'Semantic & Link' },
  { n: 6, label: 'Finalize & Publish' },
]
const stepN = computed(() => Number(step.value || 1))
const percent = computed(() => Math.round(((stepN.value - 1) / (STEPS_TOTAL - 1)) * 100))

const loading = ref(false)
const pushing = ref(false)
const catLoading = ref(false)
const articleId = ref(null)

const language = ref('Tiếng Việt')
const schemaType = ref('Article')
const mainKeyword = ref('')

const subKeywordsInput = ref('')
const subKeywords = ref([])
const selectedKeywords = ref([])

const outline = ref('')

const title = ref('')
const description = ref('')

const semanticKeywords = ref('')
const internalLinkOptions = ref([])
const selectedInternalLink = ref('')

const content = ref('')
const featuredImage = ref('')
const slug = ref('')
const focusKeywords = ref('')

const availableCtaOptions = ref([])
const selectedCtaId = ref('')
const selectedCtaContent = ref('')

const sitesForPublish = ref([])
const selectedSiteId = ref('')
const categories = ref([])
const selectedCategories = ref([])
const postStatus = ref('publish')

/* ====== TinyMCE ====== */
const TINYMCE_KEY = 'yrhpcam8qdug0kvk57vkx6kqcvs0qik1uatwa80yhh12nk1x'
const showFileManagerModal = ref(false)
const imageTabs = ref([])
const targetField = ref(null)
const fileManagerCallback = ref(null)

const tinymceInit = {
  height: 520,
  menubar: true,
  plugins: [
    'advlist','autolink','link','image','lists','charmap','preview','anchor',
    'searchreplace','visualblocks','code','fullscreen',
    'insertdatetime','media','table','paste','help','wordcount'
  ],
  toolbar: [
    'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough forecolor backcolor',
    'alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image media',
    'removeformat | table | code fullscreen | preview'
  ].join(' '),
  relative_urls: false,
  remove_script_host: false,
  toolbar_mode: 'floating',
  content_style: 'body { font-family: Inter, Helvetica, Arial, sans-serif; font-size:14px }',
  file_picker_callback: async (cb, value, meta) => {
    if (meta.filetype === 'image') {
      targetField.value = 'content'
      fileManagerCallback.value = cb
      await fetchFolders()
      showFileManagerModal.value = true
    }
  }
}

/* ====== Computed ====== */
const canCreate = computed(() => !!mainKeyword.value && !!language.value && !!schemaType.value)
const canPush = computed(() => !!selectedSiteId.value && selectedCategories.value.length > 0)

/* ====== Helpers sửa bài theo bước ====== */
const editingExisting = ref(false)

const stepEnumToN = (s) => ({
  INIT: 1,
  SUB_KEYWORDS: 2,
  OUTLINE: 3,
  TITLE_DESCRIPTION: 4,
  SEMANTIC_KEYWORDS: 5,
  CONTENT: 6,
  FINALIZED: 6,
  PUSHED: 6,
})[s] || 1

const hydrateFromArticle = (arti) => {
  if (!arti) return
  articleId.value = arti.id
  language.value = arti.language || language.value
  schemaType.value = arti.schemaType || schemaType.value
  mainKeyword.value = arti.mainKeyword || ''

  subKeywordsInput.value = arti.subKeywords || ''
  subKeywords.value = (arti.subKeywords || '').split(',').map(s=>s.trim()).filter(Boolean)
  selectedKeywords.value = [...subKeywords.value]

  outline.value = arti.outline || ''
  title.value = arti.title || ''
  description.value = arti.description || ''
  semanticKeywords.value = arti.semanticKeywords || ''

  content.value = arti.content || ''
  slug.value = arti.slug || ''
  focusKeywords.value = arti.focusKeywords || ''
  featuredImage.value = arti.featuredImage || ''

  if (arti.selectedSiteId) selectedSiteId.value = String(arti.selectedSiteId)
  if (arti.selectedCategoryIds) {
    selectedCategories.value = String(arti.selectedCategoryIds).split(',').filter(Boolean)
  }

  editingExisting.value = true
}

/* ====== Watchers ====== */
watch(subKeywordsInput, (val) => {
  subKeywords.value = (val || '').split(',').map(s => s.trim()).filter(Boolean)
})
watch(title, (t) => {
  if (!editingExisting.value && !slug.value) slug.value = slugify(t)
})
watch(selectedCtaId, (id) => {
  const found = availableCtaOptions.value.find(x => String(x.id) === String(id))
  selectedCtaContent.value = found ? found.content : ''
})
watch(selectedSiteId, async () => {
  selectedCategories.value = []
  await fetchCategories()
})
watch(stepN, async (n) => {
  if (n === 6 && articleId.value) {
    const arti = await fetchArticle(articleId.value)
    if (arti) {
      content.value = arti.content || content.value
      slug.value = arti.slug || slug.value
      focusKeywords.value = arti.focusKeywords || focusKeywords.value
      featuredImage.value = arti.featuredImage || featuredImage.value
    }
  }
})

/* ====== Helpers ====== */
const normalizeStep = (n) => { step.value = Number(n || 1) }

const slugify = (text) =>
  (text || '')
    .toString()
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .toLowerCase().trim()
    .replace(/\s+/g, '-')
    .replace(/[^\w-]+/g, '')
    .replace(/--+/g, '-')

const sleep = (ms) => new Promise(r => setTimeout(r, ms))

const fetchArticle = async (id) => {
  const res = await api.get(`/api/articles/${id}`)
  return res?.data || {}
}

const composeFocusKeywords = (main, focus) => {
  const set = new Set()
  if (main && main.trim()) set.add(main.trim())
  ;(focus || '').split(',').map(s => s.trim()).filter(Boolean).forEach(s => set.add(s))
  return Array.from(set).join(', ')
}

/**
 * Trigger 1 job AI (POST) rồi poll DB đến khi pickFn(article) true.
 */
const triggerAndPoll = async (postUrl, pickFn, opts = {}) => {
  const { tries = 40, intervalMs = 1500 } = opts
  await api.post(postUrl)
  for (let i = 0; i < tries; i++) {
    const arti = await fetchArticle(articleId.value)
    if (pickFn(arti)) return arti
    await sleep(intervalMs)
  }
  throw new Error('Hết thời gian đợi AI tạo dữ liệu.')
}

/* FileManager */
const fetchFolders = async () => {
  try {
    const res = await api.get('/api/images/folders')
    imageTabs.value = (res.data || []).map((name, i) => ({ id: String(i+1), name, folderName: name }))
  } catch (e) {
  imageTabs.value = []
  }
}
const openAvatarModal = async () => {
  targetField.value = 'avatar'
  await fetchFolders()
  showFileManagerModal.value = true
}
const onFileSelected = (image) => {
  if (!image?.url) return
  if (targetField.value === 'avatar') {
    featuredImage.value = image.url
  } else if (targetField.value === 'content' && fileManagerCallback.value) {
    fileManagerCallback.value(image.url, { alt: image.title, title: image.title })
  }
  showFileManagerModal.value = false
  fileManagerCallback.value = null
  targetField.value = null
}
const onTabCreated = (t) => imageTabs.value.push(t)
const onTabDeleted = (id) => imageTabs.value = imageTabs.value.filter(x => x.id !== id)

/* Sites & Categories */
const loadSitesForInternalLink = async () => {
  const res = await api.get('/api/wp-sites', { params: { page: 0, size: 100 } })
  internalLinkOptions.value = res?.data?.content || []
}
const loadSitesForPublish = async () => {
  const res = await api.get('/api/wp-sites', { params: { page: 0, size: 100 } })
  sitesForPublish.value = res?.data?.content || []
}
const parseCategories = (raw) => {
  if (Array.isArray(raw)) return raw
  if (raw?.content && Array.isArray(raw.content)) return raw.content
  if (raw?.data && Array.isArray(raw.data)) return raw.data
  if (raw?.items && Array.isArray(raw.items)) return raw.items
  return []
}
const fetchCategories = async () => {
  categories.value = []
  if (!selectedSiteId.value) return
  catLoading.value = true
  try {
    const res = await api.get(`/api/wp-sites/${selectedSiteId.value}/categories`)
    const arr = parseCategories(res.data)
    categories.value = arr
      .map(c => ({ id: c.id ?? c.term_id ?? c.termId, name: c.name ?? c.title ?? c.label }))
      .filter(c => c.id && c.name)
  } catch (e) {
    categories.value = []
    toast.error('Lỗi tải danh mục từ website.')
  } finally {
    catLoading.value = false
  }
}

/* ====== Flow ====== */
const createArticle = async () => {
  if (!canCreate.value) { toast.error('Nhập từ khóa chính và chọn ngôn ngữ/schema.'); return }
  loading.value = true
  try {
    const res = await api.post('/api/articles', {
      language: language.value,
      schemaType: schemaType.value,
      mainKeyword: mainKeyword.value
    })
    articleId.value = res.data.id

    // ✅ FIX: dùng triggerAndPoll để không phụ thuộc format response
    let sk = (res.data.subKeywords || '').trim()
    if (!sk) {
      const arti = await triggerAndPoll(
        `/api/articles/${articleId.value}/sub-keywords/ai`,
        (a) => !!a?.subKeywords
      )
      sk = (arti.subKeywords || '').trim()
    }

    subKeywordsInput.value = sk
    subKeywords.value = sk.split(',').map(s => s.trim()).filter(Boolean)
    selectedKeywords.value = [...subKeywords.value]

    await Promise.all([loadSitesForInternalLink(), loadSitesForPublish(), loadCtas()])
    normalizeStep(2)
    toast.success('Tạo bài & lấy SubKeywords thành công!')
  } catch (e) {
    toast.error('Không thể tạo bài viết.')
  } finally {
    loading.value = false
  }
}

const saveSubKeywords = async () => {
  if (!articleId.value) return
  loading.value = true
  try {
    const joined = selectedKeywords.value.join(',')
    await api.put(`/api/articles/${articleId.value}`, {
      subKeywords: joined,
      language: language.value,
      schemaType: schemaType.value,
      mainKeyword: mainKeyword.value
    })
    toast.success('Đã lưu từ khóa phụ.')
  } catch {
    toast.error('Lỗi lưu từ khóa phụ.')
  } finally {
    loading.value = false
  }
}

const generateOutline = async () => {
  loading.value = true
  try {
    const arti = await triggerAndPoll(
      `/api/articles/${articleId.value}/outline/ai`,
      (a) => !!a?.outline
    )
    outline.value = arti.outline || ''
    normalizeStep(3)
    toast.success('Đã sinh outline.')
  } catch (e) {
    toast.error(e.message || 'Không thể sinh outline.')
  } finally {
    loading.value = false
  }
}

const generateTitleDesc = async () => {
  loading.value = true
  try {
    const arti = await triggerAndPoll(
      `/api/articles/${articleId.value}/title-description/ai`,
      (a) => !!(a?.title && a?.description)
    )
    title.value = arti.title || ''
    description.value = arti.description || ''
    normalizeStep(4)
    toast.success('Đã sinh tiêu đề & mô tả.')
  } catch (e) {
    toast.error(e.message || 'Không thể sinh title/description.')
  } finally {
    loading.value = false
  }
}

const saveTitleDescThenGenSemantic = async () => {
  if (!articleId.value) return
  loading.value = true
  try {
    await api.put(`/api/articles/${articleId.value}/title-description`, {
      title: title.value,
      description: description.value
    })
    const arti = await triggerAndPoll(
      `/api/articles/${articleId.value}/semantic-keywords/ai`,
      (a) => !!a?.semanticKeywords
    )
    semanticKeywords.value = arti.semanticKeywords || ''
    normalizeStep(5)
    toast.success('Đã lưu & sinh semantic keywords.')
  } catch (e) {
    toast.error(e.message || 'Không thể sinh semantic keywords.')
  } finally {
    loading.value = false
  }
}

const saveUrlAndGenerateContent = async () => {
  if (!articleId.value) return
  if (!selectedInternalLink.value) { toast.error('Chọn 1 Internal Link'); return }
  loading.value = true
  try {
    if (semanticKeywords.value) {
      await api.put(`/api/articles/${articleId.value}/semantic-keywords`, { semanticKeywords: semanticKeywords.value })
    }
    await api.put(`/api/articles/${articleId.value}/internal-links`, { internalLinks: selectedInternalLink.value })

    const arti = await triggerAndPoll(
      `/api/articles/${articleId.value}/content/ai`,
      (a) => !!a?.content
    )

    content.value = arti.content || ''
    if (arti.slug) slug.value = arti.slug
    if (!focusKeywords.value) {
      focusKeywords.value = arti.focusKeywords || semanticKeywords.value || mainKeyword.value
    }
    if (arti.featuredImage && !featuredImage.value) {
      featuredImage.value = arti.featuredImage
    }

    normalizeStep(6)
    toast.success('Đã sinh nội dung.')
  } catch (e) {
    toast.error(e.message || 'Không thể sinh content.')
  } finally {
    loading.value = false
  }
}

const loadCtas = async () => {
  try {
    const ctaRes = await api.get('/api/ctas')
    const list = ctaRes?.data?.content || []
    availableCtaOptions.value = list.map(c => ({ id: c.id, name: c.name, content: c.ctaContent }))
  } catch {
    availableCtaOptions.value = []
  }
}

const finalizeArticle = async () => {
  if (!articleId.value) return
  loading.value = true
  try {
    await api.put(`/api/articles/${articleId.value}/content`, {
      content: content.value,
      slug: slug.value || undefined
    })
    if (selectedCtaId.value) {
      await api.put(`/api/articles/${articleId.value}`, { ctaId: selectedCtaId.value })
    }
    const focusCombined = composeFocusKeywords(mainKeyword.value, focusKeywords.value)
    await api.put(`/api/articles/${articleId.value}/finalize`, {
      content: content.value,
      featuredImage: featuredImage.value || undefined,
      focusKeywords: focusCombined || undefined,
      status: 'FINALIZED'
    })
    toast.success('Đã lưu (Finalize).')
  } catch (e) {
    toast.error('Finalize thất bại.')
  } finally {
    loading.value = false
  }
}

const testWp = async () => {
  if (!selectedSiteId.value) { toast.error('Chọn site trước.'); return }
  pushing.value = true
  try {
    const pf = await api.get('/api/articles/wp/preflight', { params: { siteId: selectedSiteId.value } })
    const d = pf.data || {}
    const okUsers = d?.users_me?.ok
    const okTypes = d?.types_post?.ok
    toast[okUsers && okTypes ? 'success' : 'error'](`Preflight: users_me=${d?.users_me?.status}, types_post=${d?.types_post?.status}`)
  } catch {
    toast.error('Preflight lỗi.')
  } finally { pushing.value = false }
}

const pushToWordpress = async () => {
  if (pushing.value) return
  if (!articleId.value) return
  if (!selectedSiteId.value || selectedCategories.value.length === 0) {
    toast.error('Chọn site và ít nhất 1 danh mục.')
    return
  }
  if (!selectedCtaId.value) { toast.error('Chọn CTA trước khi đăng.'); return }
  if (!featuredImage.value) { toast.error('Chọn ảnh đại diện trước khi đăng.'); return }

  pushing.value = true
  try {
    await api.put(`/api/articles/${articleId.value}/content`, {
      content: content.value,
      slug: slug.value || undefined
    })

    await api.post(`/api/articles/${articleId.value}/push`, {
      wpSiteId: selectedSiteId.value,
      categories: selectedCategories.value,
      status: postStatus.value,
      ctaId: selectedCtaId.value,
      featuredImage: featuredImage.value,
      focusKeywords: focusKeywords.value
    })

    toast.success('Đăng bài thành công!')
  } catch (e) {
    toast.error('Đăng bài thất bại.')
  } finally {
    pushing.value = false
  }
}

/* Init */
onMounted(async () => {
  await Promise.all([loadSitesForInternalLink(), loadSitesForPublish(), loadCtas()])

  const idFromParam = route?.params?.id ? Number(route.params.id) : null
  const idFromQuery = route?.query?.id ? Number(route.query.id) : null
  const idToLoad = idFromParam || idFromQuery

  if (idToLoad) {
    try {
      const arti = await fetchArticle(idToLoad)
      hydrateFromArticle(arti)
      const qStep = route?.query?.step ? Number(route.query.step) : null
      const n = qStep && qStep >= 1 && qStep <= 6 ? qStep : stepEnumToN(arti.step)
      normalizeStep(n)
    } catch (e) {
      toast.error('Không tải được bài cần sửa.')
      // router.replace({ name: 'ArticleList' })
    }
  }
})
</script>

<style scoped>
.steps-bar .nav-link {
  margin-right: .5rem;
  background: #f8f9fa;
  color: #6c757d;
  border: 1px solid #e9ecef;
  border-radius: 50rem;
  padding: .35rem .75rem;
}
.steps-bar .nav-link.active {
  background: #007bff;
  color: #fff;
  border-color: #007bff;
}
.steps-bar .nav-link.disabled {
  opacity: .6;
  pointer-events: none;
}
.cats-scroll { max-height: 240px; overflow: auto; border: 1px solid #e9ecef; border-radius: .25rem; padding: .5rem .75rem; background: #fff; }
.kw-cloud { background: #f8f9fa; border: 1px dashed #e9ecef; padding: .75rem; border-radius: .25rem; }
.kw-chip { margin: 4px 8px 4px 0; background: #fff; border: 1px solid #e9ecef; padding: 6px 10px; border-radius: 50rem; }
.sticky-panel { position: sticky; top: 76px; }
.cta-preview { border-color: #e9ecef !important; }
</style>
